import React, { useEffect, useState } from "react";
import * as Constants from "../../../../Constants/index";
import axios from "axios";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import { useFormik } from "formik";
import ResponsivePagination from "react-responsive-pagination";
import Oval from "../../loader/CircleLoade";
import { Link } from "react-router-dom";
import Navbar from "../../../common/Navbar";

export default function RetailerDashboard() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [faqsurl, setFaqsurl] = useState("");
  const [tncurl, setTncurl] = useState("");
  const [schemeurl, setSchemeurl] = useState("");
  const [rewardurl, setRewardurl] = useState("");
  const [evgurl, setEvgurl] = useState("");
  const [dashboardData, setDashboardData] = useState({});
  const [checkPopUp, setCheckPopUp] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showRedemptionPopup, setShowRedemptionPopup] = useState(false);

  const [getPointsData, setGetPointsData] = useState({
    points: "",
    newPoints: "",
    redeemedPoints: "",
    newRedeemedPoints: "",
    tds: "",
    newTotalPoints: "",
  });

  useEffect(() => {
    getUserDetails();
    getDashboardData();
    getFaqsData();
    getEVGUrl();
  }, []);

  const getDashboardData = async () => {
    if (!token) {
      navigate("/");
    } else {
      await axios
        .get(`${Constants.baseUrl}purchase/purchaseHistory/retailer`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("langauge"),
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: Constants.program2,
          },
        })
        .then((res) => {
          const dt = res.data;
          if (dt.result === "success") {
            setDashboardData(dt?.output);
          }
          if (dt.result === "error" || dt.result === "dialog") {
            setDashboardData({});
          }
        })
        .catch((err) => {});
    }
  };

  const getFaqsData = async () => {
    if (!token) {
      navigate("/");
    } else {
      await axios
        .get(`${Constants.baseUrl}program/child/2`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("langauge"),
            // appVersion: Constants.av,
            // platform: Constants.pt,
            // company: Constants.company,
            // program: Constants.program,
          },
        })
        .then((res) => {
          const dt = res.data;
          if (dt.result === "success") {
            setFaqsurl(dt?.output?.faqs);
            setTncurl(dt?.output?.tnc);
            setSchemeurl(dt?.output?.catelog);
            setRewardurl(dt?.output?.manual);
          }
        })
        .catch((err) => {});
    }
  };

  const getEVGUrl = async () => {
    if (!token) {
      navigate("/");
    } else {
      await axios
        .post(
          `${Constants.baseUrl}web/evg/view_url`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Accept-Language": localStorage.getItem("langauge"),
              appVersion: Constants.av,
              platform: Constants.pt,
              company: Constants.company,
              program: Constants.program,
            },
          },
        )
        .then((res) => {
          const dt = res.data;
          if (dt.result === "success") {
            setEvgurl(dt?.output?.url);
          }
        })
        .catch((err) => {});
    }
  };

  const getUserDetails = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await axios.post(
        Constants.baseUrl + "auth/profile/get",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("langauge"),
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: Constants.program,
          },
        },
      );
      if (res?.data?.output) {
        const data = res.data.output;

        setGetPointsData({
          points: data.points ?? 0,
          newPoints: data.newPoints ?? 0,
          redeemedPoints: data.redeemedPoints ?? 0,
          newRedeemedPoints: data.newRedeemedPoints ?? 0,
          tds: data.tds ?? 0,
          newTotalPoints: data.newTotalPoints ?? 0,
        });
      }
      if (res.data.output?.upiStop === true) {
        setCheckPopUp(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpiRedemptionClick = (e) => {
    if (checkPopUp) {
      e.preventDefault();
      setShowPopup(true);
    }
    // If checkPopUp is false, allow normal navigation
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const handleRedemptionClick = (e) => {
    setShowRedemptionPopup(true);
  };

  const closeRedemptionPopup = () => {
    setShowRedemptionPopup(false);
  };

  const summaryItems = [
    {
      label: "Redeemable Points",
      value: Number(getPointsData?.points + getPointsData?.newPoints),
      prefix: "",
    },
    {
      label: "Redeemed Points",
      value: Number(
        getPointsData?.redeemedPoints + getPointsData?.newRedeemedPoints,
      ),
      prefix: "",
    },
    {
      label: "Old Points",
      value: Number(getPointsData?.points),
      prefix: "",
      pointOne: "Earned on/before 31-Oct-25",
      pointTwo: "Redeemable only as Vouchers",
    },
    {
      label: "New Points",
      value: Number(getPointsData?.newPoints),
      prefix: "",
      pointOne: "Earned on/after 1-Nov-25",
      pointTwo: "Redeemable via UPI and Vouchers",
      pointThree: `T.D.S : ${getPointsData?.tds} pts`,
      pointFour: `Total Earning So Far: ${getPointsData?.newTotalPoints} pts`,
    },
    // {
    //   label: "Opening 'Locked' Rewards on 30 - Nov - 22",
    //   value: dashboardData?.lockedPoint,
    //   prefix: "Rs. ",
    // },
    // {
    //   label: "Earned 'Unlocked' Rewards w.e.f. 01 - Dec - 22",
    //   value: dashboardData?.earnedPointCurentMonth,
    //   prefix: "Rs. ",
    // },
    // {
    //   label: "TDS u/ s 194R w.e.f. 01 - Dec - 22",
    //   value: dashboardData?.onTdsPct,
    //   prefix: "Rs. ",
    // },
    // {
    //   label: "Redeemed w.e.f. 01 - Dec - 22",
    //   value: dashboardData?.redeemed,
    //   prefix: "Rs. ",
    // },
    // {
    //   label: "Total 'Locked + Unlocked' Rewards Balance",
    //   value: dashboardData?.totalLockedULocked,
    //   prefix: "Rs. ",
    // },
    // {
    //   label: "Redeemable in current month",
    //   value: dashboardData?.reedeemableCurentMonth,
    //   prefix: "Rs. ",
    // },
    // {
    //   label: "Rewards Earned in Current Month (Including TDS)",
    //   value: dashboardData?.cuurentMonthTds,
    //   prefix: "Rs. ",
    // },
  ];

  return (
    <>
      <Navbar />
      <section className="page-content--bge55">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3 left-menu">
              <div className="item">
                <p className="top-title">TOTAL EARNED INCENTIVE:</p>
                <ul className="retailer-side-list">
                  {summaryItems.map((item, index) => {
                    const detailPoints = [
                      item.pointOne,
                      item.pointTwo,
                      item.pointThree,
                      item.pointFour,
                    ].filter(Boolean);

                    return (
                      <li key={item.label} className="retailer-side-list-item">
                        <div className="retailer-side-header">
                          <div
                            className="retailer-side-copy"
                            style={{ fontWeight: "bolder" }}
                          >
                            <p>{item.label}</p>
                          </div>
                          <div className="retailer-side-value-wrap">
                            <span className="button-style2">
                              {item.prefix}
                              {item.value ?? 0}
                            </span>
                          </div>
                        </div>
                        {detailPoints.length > 0 ? (
                          <ul
                            className="retailer-side-points"
                            style={{ fontWeight: "lighter" }}
                          >
                            {detailPoints.map((point) => (
                              <li key={point} className="retailer-side-point">
                                {point}
                              </li>
                            ))}
                          </ul>
                        ) : null}
                        {index !== summaryItems.length - 1 ? (
                          <hr className="separatehr" />
                        ) : null}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>

            <div className="col-md-9">
              <div className="row">
                <div className="col-md-12">
                  <h3 className="head1">Dashboard</h3>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/Purchase_History">
                      <span>
                        <i className="fa fa-file-text-o"></i>
                      </span>
                      <p>Purchase History</p>
                    </Link>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/RewardPoints">
                      <span>
                        <i className="fa fa-star"></i>
                      </span>
                      <p>Reward Points</p>
                    </Link>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/redeemption">
                      <span>
                        <i className="fa fa-money"></i>
                      </span>
                      <p>Redeemption</p>
                    </Link>
                  </div>
                </div>

                {/* <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link
                      //to="/redeemption"
                      onClick={handleRedemptionClick}
                    >
                      <span>
                        <i className="fa fa-money"></i>
                      </span>
                      <p>Redeemption</p>
                    </Link>
                  </div>
                </div> */}

                {/* <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link 
                      to="/upi_redeemption" 
                      onClick={handleUpiRedemptionClick}
                    >
                      <span>
                        <i className="fa fa-money"></i>
                      </span>
                      <p>UPI Redeemption</p>
                    </Link>
                  </div>
                </div> */}

                {/* <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to={evgurl} target="_blank">
                      <span>
                        <i className="fa fa-trophy"></i>
                      </span>
                      <p>Redeem Electronic Gift Voucher</p>
                    </Link>
                  </div>
                </div> */}

                {/* <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/VoucherRedemptionHistory">
                      <span>
                        <i className="fa fa-history"></i>
                      </span>
                      <p>Discount Voucher Redemption History</p>
                    </Link>
                  </div>
                </div> */}

                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/redemption_history">
                      <span>
                        <i className="fa fa-history"></i>
                      </span>
                      <p>Redemption History</p>
                    </Link>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/order_indent">
                      <span>
                        <i className="fa fa-shopping-cart"></i>
                      </span>
                      <p>Order Indent</p>
                    </Link>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/videos">
                      <span>
                        <i className="fa fa-video-camera"></i>
                      </span>
                      <p>Videos</p>
                    </Link>
                  </div>
                </div>
                {/* <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/PlumberList">
                      <span>
                        <i className="fa fa-user"></i>
                      </span>
                      <p>Manage Plumber</p>
                    </Link>
                  </div>
                </div> */}

                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link
                      to={schemeurl}
                      target="_blank"
                      title="Schemes &amp; Promotions"
                    >
                      Schemes &amp; Promotions
                    </Link>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to={rewardurl} target="_blank">
                      <span>
                        <i className="fa fa-gift"></i>
                      </span>
                      <p>Reward Matrix</p>
                    </Link>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/feedback_support">
                      <span>
                        <i className="fa fa-phone-square"></i>
                      </span>
                      <p>Feedback / Support</p>
                    </Link>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    {/* <Link to="/faq"> */}
                    <Link to={faqsurl} target="_blank">
                      <span>
                        <i className="fa fa-question-circle"></i>
                      </span>
                      <p>FAQs</p>
                    </Link>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    {/* <Link to="/tnc"> */}
                    <Link to={tncurl} target="_blank">
                      <span>
                        <i className="fa fa-file"></i>
                      </span>
                      <p>Terms &amp; Conditions</p>
                    </Link>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/makewish">
                      <span>
                        <i className="fa fa-magic"></i>
                      </span>
                      <p>Make a Wish</p>
                    </Link>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/make_a_wish_history">
                      <span>
                        <i className="fa fa-circle-o-notch"></i>
                      </span>
                      <p>Make a Wish History</p>
                    </Link>
                  </div>
                </div>

                {/* <div className="col-md-3">
                  <div className="dashboard-item" tabindex="0">
                    <Link to="/upload_shop_image_rate">
                      <span>
                        <i className="fa fa-picture-o"></i>
                      </span>
                      <p>Display Incentive</p>
                    </Link>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Popup Modal */}
      {showPopup && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            className="modal-content"
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              maxWidth: "400px",
              width: "90%",
              textAlign: "center",
            }}
          >
            <h3 style={{ marginBottom: "15px", color: "#333" }}>Coming Soon</h3>
            <p style={{ marginBottom: "20px", color: "#666" }}>
              UPI Redemption feature is coming soon. Please check back later.
            </p>
            <button
              onClick={closePopup}
              style={{
                backgroundColor: "rgb(82, 184, 184)",
                color: "white",
                border: "none",
                padding: "10px 20px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {showRedemptionPopup && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            className="modal-content"
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              maxWidth: "400px",
              width: "90%",
              textAlign: "center",
            }}
          >
            <h3 style={{ marginBottom: "15px", color: "#333" }}>Coming Soon</h3>
            <p style={{ marginBottom: "20px", color: "#666" }}>
              Redemption feature is coming soon. Please check back later.
            </p>
            <button
              onClick={closeRedemptionPopup}
              style={{
                backgroundColor: "rgb(82, 184, 184)",
                color: "white",
                border: "none",
                padding: "10px 20px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
      <style>{`
        .retailer-side-list {
          margin: 0;
          padding: 0;
          list-style: none;
        }

        .retailer-side-list-item {
          margin-bottom: 0;
          padding: 18px 0 0;
        }

        .retailer-side-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
        }

        .retailer-side-copy p {
          margin: 0;
          line-height: 1.45;
        }

        .retailer-side-points {
          margin: 12px 0 0;
          padding-left: 22px;
          list-style-type: disc;
          list-style-position: outside;
        }

        .retailer-side-point {
          display: list-item;
          font-weight: 300;
          line-height: 1.5;
        }

        .retailer-side-point::marker {
          color: #ffffff;
        }

        .retailer-side-point + .retailer-side-point {
          margin-top: 8px;
        }

        .retailer-side-value-wrap {
          display: flex;
          justify-content: flex-end;
          flex-shrink: 0;
          margin-top: 0;
        }
      `}</style>
    </>
  );
}
